import React from 'react'
import PropTypes from 'prop-types'
import { WebView } from '@vfgroup-oneplatform/framework/CommonUI'
import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

import Modal from '../Modal'

function Browser({
  isVisible,
  url,
  closeBrowser,
}) {

  return (
    <Modal
      visible={isVisible}
      close={closeBrowser}
      backdropTransitionInTiming={0}
      backdropTransitionOutTiming={0}
      backdropOpacity={0}
      useNativeDriver={true}
      type="full"
      coverScreen
      showUpperDash={false}
      statusBarColor={Colors.whiteSmoke}
    >
      <WebView
        url={url}
        onClose={closeBrowser}
        setSupportZoom={true}
        navigation
      />
    </Modal>
  )
}
Browser.propTypes = {
  isVisible: PropTypes.bool,
  url: PropTypes.string,
  closeBrowser: PropTypes.func,
}

export default Browser
